import { reactive } from "vue";
import translations from "../translations";

const state = reactive<{
  title: string;
  description: string;
  departureTime: Date | null;
  arrivalTime: Date | null;
  departureLocation: {
    description: string;
    lat: number;
    lon: number;
  } | null;
}>({
  title: translations.title,
  description: translations.description,
  departureTime: null,
  arrivalTime: null,
  departureLocation: null,
});
export default state;
export function toDefault() {
  state.title = translations.title;
  state.description = translations.description;
  state.departureTime = null;
  state.arrivalTime = null;
  state.departureLocation = null;
}
toDefault();
